module.exports = __webpack_public_path__ + "img/CardImage8.2900252c.png";